import { ProjectAuthType } from "@prisma/client";
import { useCurrentProject } from "lib/context/current-project-context";
import { usePageContext } from "lib/context/page-context";
import { trpc } from "utils/trpc";

export function useConsumer() {
  const { isEditing, isThumbnail } = usePageContext();
  const project = useCurrentProject();

  const { data: consumer } = trpc.consumers.me.useQuery(undefined, {
    enabled:
      project.authType === ProjectAuthType.Consumer &&
      !isEditing &&
      !isThumbnail,
  });

  return consumer;
}
